import React, { useState } from "react";
import Chatbot from "react-chatbot-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import config from "./config";
import MessageParser from "./MessageParser";
import ActionProvider from "./ActionProvider";
import "react-chatbot-kit/build/main.css";
import "./staticChatbot.css";

const StaticChatbot = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="static-chatbot-wrapper">
      {isOpen && (
        <div className="static-chatbot-panel">
          <Chatbot
            config={config}
            messageParser={MessageParser}
            actionProvider={ActionProvider}
            placeholderText="Type your question..."
            disableScrollToBottom={false}
          />
        </div>
      )}

      <button
        type="button"
        className="static-chatbot-toggle"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label={isOpen ? "Close support chatbot" : "Open support chatbot"}
      >
        <FontAwesomeIcon icon={isOpen ? faXmark : faWhatsapp} />
      </button>
    </div>
  );
};

export default StaticChatbot;
